import React from "react";
import useStyles from "./FmGreenDescription.style";
import { useTranslation } from "react-i18next";
import { useIsMobile, useTheme } from "../../../../Hooks";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState, RootState } from "../../../../Redux";
import { Accordion, AccordionDetails, AccordionSummary, Stack, SvgIcon } from "@mui/material";
import { ShowWhen } from "../../../../Components/ShowWhen";

const CustomArrow = () => {
  return (
    <SvgIcon sx={{ width: 14 }} width="14" height="6" viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.97235 -2.64685e-07C11.0122 -1.73782e-07 11.4907 1.29366 10.7012 1.97037L6.72889 5.37524C6.30946 5.73475 5.69054 5.73475 5.27111 5.37524L1.29876 1.97037C0.509275 1.29366 0.987833 -1.05014e-06 2.02765 -9.59233e-07L9.97235 -2.64685e-07Z"
        fill="#00833E"
      />
    </SvgIcon>
  );
};

const FmGreenDescription = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isOpen = useSelector((state: RootState) => state.agriSolution.releaseGraphState.isGreenDescriptionOpen);
  const theme = useTheme();
  const dispatch = useDispatch();

  const onExpand = () => {
    dispatch(AgriSolutionState.Actions.toggleGreenDescription());
  };

  function getArrowStyles() {
    if (isOpen) {
      return {
        padding: "0 24px",
        marginBottom: "-57px",
        paddingTop: "20px",
      };
    }

    return {
      padding: "0 24px",
    };
  }

  return (
    <Accordion expanded={isOpen} sx={{ backgroundColor: "#E4F5EC", boxShadow: "none" }}>
      <AccordionSummary onClick={onExpand} expandIcon={<CustomArrow />} sx={getArrowStyles()}>
        <ShowWhen when={!isOpen}>
          <div className={classes.box_title} style={{ padding: "0 13px" }}>
            {t("PageReleaseChart.greenMessage.title1")}
          </div>
        </ShowWhen>
      </AccordionSummary>

      <AccordionDetails>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <div className={classes.leftSide}>
            <div className={isMobile ? classes.mobile_box : classes.box}>
              <div className={classes.box_title}>{t("PageReleaseChart.greenMessage.title1")}</div>
              <span>{t("PageReleaseChart.greenMessage.description1")}</span>
              <span className={classes.marginBox}>{t("PageReleaseChart.greenMessage.description2")}</span>
              <span>
                <span className={classes.bold}>{t("PageReleaseChart.greenMessage.subTitle")}</span> {t("PageReleaseChart.greenMessage.description3")}
              </span>
            </div>

            <div className={isMobile ? classes.mobile_box : classes.box}>
              <div className={classes.box_title}>{t("PageReleaseChart.greenMessage.title2")}</div>
              <span>{t("PageReleaseChart.greenMessage.description4")}</span>
            </div>
          </div>

          <div className={classes.rightSide}>
            <div className={isMobile ? classes.mobile_box : classes.box}>
              <div className={classes.box_title}>{t("PageReleaseChart.greenMessage.title3")}</div>
              <span>{t("PageReleaseChart.greenMessage.description5")}</span>
            </div>

            <div className={isMobile ? classes.mobile_box : classes.box}>
              <div className={classes.box_title}>{t("PageReleaseChart.greenMessage.title4")}</div>
              <span>{t("PageReleaseChart.greenMessage.description6")}</span>
            </div>
          </div>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );

  /* Old design beofre accordion

  if (!isOpen) {
    return (
      <FmBox variant="green" className={classes.smallGreenDesc}>
        <div className={classes.box_title}>{t('PageReleaseChart.greenMessage.title1')}</div>

        <FmIcon
          url={theme.images.filledUpArrow}
          className={classes.smallGreenDescArrowOpen}
          onClick={() => dispatch(AgriSolutionState.Actions.toggleGreenDescription())}
        />
      </FmBox>
    );
  }

  return (
    <div className={isMobile ? classes.mobile_container : classes.container}>
      <FmIcon
        url={theme.images.filledUpArrow}
        className={classes.smallGreenDescArrow}
        onClick={() => dispatch(AgriSolutionState.Actions.toggleGreenDescription())}
      />

      <div className={classes.leftSide}>
        <div className={isMobile ? classes.mobile_box : classes.box}>
          <div className={classes.box_title}>{t('PageReleaseChart.greenMessage.title1')}</div>
          <span>{t('PageReleaseChart.greenMessage.description1')}</span>
          <span className={classes.marginBox}>{t('PageReleaseChart.greenMessage.description2')}</span>
          <span>
            <span className={classes.bold}>{t('PageReleaseChart.greenMessage.subTitle')}</span>{' '}
            {t('PageReleaseChart.greenMessage.description3')}
          </span>
        </div>

        <div className={isMobile ? classes.mobile_box : classes.box}>
          <div className={classes.box_title}>{t('PageReleaseChart.greenMessage.title2')}</div>
          <span>{t('PageReleaseChart.greenMessage.description4')}</span>
        </div>
      </div>

      <div className={classes.rightSide}>
        <div className={isMobile ? classes.mobile_box : classes.box}>
          <div className={classes.box_title}>{t('PageReleaseChart.greenMessage.title3')}</div>
          <span>{t('PageReleaseChart.greenMessage.description5')}</span>
        </div>

        <div className={isMobile ? classes.mobile_box : classes.box}>
          <div className={classes.box_title}>{t('PageReleaseChart.greenMessage.title4')}</div>
          <span>{t('PageReleaseChart.greenMessage.description6')}</span>
        </div>
      </div>
    </div>
  );
  */
};

export default React.memo(FmGreenDescription);
